import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface CalloutProps extends BoxProps {
  children: React.ReactNode
}

const Root = styled(Box)({
  padding: '14px 16px',
  borderRadius: 13,
  background: 'var(--ds-gradient-spectrum-soft, var(--ds-hover))',
  fontSize: 12,
  lineHeight: 1.55,
  color: 'var(--ds-ink-muted)',
  '& b, & strong': {
    color: 'var(--ds-ink)',
    fontWeight: 650,
  },
})

/** Soft spectrum info callout — key teases, gentle tips, non-alert messaging. */
export function Callout({ children, ...rest }: CalloutProps) {
  return <Root {...rest}>{children}</Root>
}
